// extracted by mini-css-extract-plugin
module.exports = {"pt-sample-detail":"pt-sample-detail-2f01449b0684e5b937ecdb6d27bd3b02","sample-footer":"sample-footer-03982808485ef38581c26cd3b8c4bfbe"};